// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import React from 'react'
import { array, bool, func, string } from 'prop-types'
import Options from './Options'
import ModalTemplates from './ModalTemplates'
import { MenuWrapper } from 'components/SearchAndSelect/Sets/common'

const Menu = props => {
  const {
    allRowsHighlighted,
    highlightedRows,
    idRoot,
    sourceForm,
    triggerSearch,
  } = props

  return (
    <MenuWrapper
      allRowsHighlighted={allRowsHighlighted}
      highlightedRows={highlightedRows}
      idRoot={idRoot}
      ModalTemplates={ModalTemplates}
      Options={Options}
      sourceForm={sourceForm}
      triggerSearch={triggerSearch} />
  )
}

Menu.propTypes = {
  allRowsHighlighted: bool.isRequired,
  highlightedRows: array.isRequired,
  idRoot: string.isRequired,
  sourceForm: string.isRequired,
  triggerSearch: func.isRequired,
}

export default Menu
